import NewButton from './NewButton';
import EnableEditButton from './EnableEditButton';
import XLSXDownloadButton from './XLSXDownloadButton';
import CSVDownloadButton from './CSVDownloadButton';
import IndeterminateCheckbox from './IndeterminateCheckbox';

const Controls = {
    NewButton,
    EnableEditButton,
    XLSXDownloadButton,
    CSVDownloadButton,
    IndeterminateCheckbox
};

export default Controls;
